export default {
  mustBePhoneNumber: (n = '') => {
    if (!n) return true;

    let number;
    const pattern = /^([0]{1})([7-9]{1})([0|1]{1})([\d]{1})([\d]{7})$/g;

    if (!n || n.length < 5) return false;

    if (typeof n === 'number') {
      // numbers never begin with 0, force this to become a string
      number = `0${n}`;
    } else if (typeof n === 'string') {
      number = n;
    } else {
      return false;
    }

    // remove all whitespace(s) before running test
    number = number.replace(/\s+/g, '');
    return pattern.test(number);
  },
  mustBeValidAmount(value = '') {
    return parseInt(value, 10) >= 100;
  },
  mustBeValidMeter(value = '') {
    return value != null && value.length > 0;
  },
  discoIdToDiscoName(id = 0) {
    switch (id) {
      case 1:
        return 'ABUJA ELECTRICITY DISTRIBUTION COMPANY';
      case 2:
        return 'ABUJA ELECTRICITY DISTRIBUTION COMPANY';
      case 3:
        return 'ABUJA ELECTRICITY DISTRIBUTION COMPANY';
      case 4:
        return 'ABUJA ELECTRICITY DISTRIBUTION COMPANY';
      case 5:
        return 'JED';
      case 6:
        return 'JED';
      case 7:
        return 'JED';
      case 8:
        return 'JED';
      case 9:
        return 'KEDC';
      case 10:
        return 'KEDC';
      case 11:
        return 'KEDC';
      case 12:
        return 'KEDC';
      default:
        return null;
    }
  },
  discoIdToDiscoLabelName(id = 0) {
    switch (id) {
      case 1:
        return 'ABUJA ELECTRICITY DISTRIBUTION COMPANY';
      case 2:
        return 'ABUJA ELECTRICITY DISTRIBUTION COMPANY';
      case 3:
        return 'ABUJA ELECTRICITY DISTRIBUTION COMPANY';
      case 4:
        return 'ABUJA ELECTRICITY DISTRIBUTION COMPANY';
      case 5:
        return 'JED PLC';
      case 6:
        return 'JED PLC';
      case 7:
        return 'JED PLC';
      case 8:
        return 'JED PLC';
      case 9:
        return 'KAEDCO';
      case 10:
        return 'KAEDCO';
      case 11:
        return 'KAEDCO';
      case 12:
        return 'KAEDCO';
      default:
        return '';
    }
  },
};
